export const stepOneData = [
  {
    heading:
      "Why Use MinEMI’s EMI Calculator for Personal Loan Balance Transfers?",
    // paras before heading

    infoList: [
      {
        heading: " Accurate EMI Estimates: ",
        description:
          "Get precise monthly repayment calculations based on loan amount, interest rate, and tenure.",
      },
      {
        heading: " Compare Loan Offers: ",
        description:
          "Evaluate EMIs across lenders to find the best deal for your needs.",
      },
      {
        heading: "Understand Savings:",
        description:
          "MinEMI shows your potential savings on interest and EMIs instantly.",
      },
      {
        heading: " Plan Efficiently:  ",
        description:
          " Simulate various repayment scenarios to make informed financial decisions.",
      },
      {
        heading: "Transparent and User-Friendly:  ",
        description:
          "MinEMI’s calculator provides clarity on all costs, including fees and total repayment.",
      },
    ],
    headingTwo:
      "What You Can Do With the Personal Loan Balance Transfer EMI Calculator?",
    // paras before heading

    infoListTwo: [
      {
        heading: " Estimate Monthly Payments:",
        description:
          "Enter your loan amount, current and new interest rates, and tenure to calculate your new EMI instantly.",
      },
      {
        heading: " Simulate Loan Scenarios: ",
        description:
          "Adjust the loan amount, tenure, or interest rates to see how they affect your EMIs and savings.",
      },
      {
        heading: " Evaluate Transfer Costs and Savings:",
        description:
          "Understand the balance transfer fee, total interest saved, and net financial gain.",
      },
    ],
    minemiTip: [
      {
        info: "A lower interest rate can significantly reduce your monthly EMI and total repayment cost.",
      },
      {
        info: "Use MinEMI to compare lenders and find the most competitive rates.",
      },
    ],
  },
];

export const stepTwoData = [
  {
    minemiTip: [
      {
        info: " Transferring during the early or mid-tenure of your loan maximizes savings.",
      },
      {
        info: "Use the calculator to evaluate the best time to switch lenders for better terms.",
      },
    ],
    heading: "How to Maximize Savings on Your Personal Loan EMI",

    infoList: [
      {
        heading: "Compare Interest Rates:",
        info: "Even a 1% reduction in the interest rate can result in substantial savings over the loan tenure.",
      },
      {
        heading: " Prepayment Options:",
        info: "Use MinEMI’s Prepayment Calculator to check how a lump-sum payment can reduce your principal and EMIs.",
      },
      {
        heading: "Balance Transfer Early:",
        info: "The earlier you transfer your loan, the more interest savings you achieve.",
      },
    ],

    minemiTipTwo: [
      {
        info: "Balance transfers usually involve a processing fee (1-3% of the loan amount).",
      },
      {
        info: "Use the calculator to check if the savings outweigh these costs before making a decision.",
      },
    ],

    paraOne: "Take Control of Your Personal Loan with MinEMI",
    paraTwo:
      "With MinEMI’s Personal Loan Balance Transfer EMI Calculator, you can confidently manage your finances, reduce your EMIs, and save more. Start calculating today and take the first step toward financial freedom!",
  },
];
